import "./AddNewUser.scss";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BeatLoader } from 'react-spinners';

import Sidebar from "../sidebar/Sidebar";
import { styled } from '@mui/material/styles';
import Navbar from "../navbar/Navbar";
import newRequest from "../../utils/newRequest";
import CustomSnakebar from "../../utils/CustomSnakebar";
import Switch from '@mui/material/Switch';
import { FormControlLabel } from "@mui/material";
import { useTranslation } from "react-i18next";
const AddNewUser = ({ inputs, title,
}) => {
    const [state, setState] = useState({
        adminaccess: 0,
        // TRXNewAssets: 0,
        // TRXExistingAssets: 0,
        // TRXInventory: 0,
        // TRXassetMovementInternalTransfer: 0,
        // TRXAssetMovementforRepair: 0,
        // TRXAssetMovementforDisposed: 0,
        // TRXAssetMovementforReturns: 0,
        // TRXAssetTagGenerateEnable: 0,
        // TRXAssetTagPrintingAllow: 0,
        // TRXAllowImportExternalFile: 0,
    });
    const [textInput, setTextInput] = useState({
        loginname: "",
        email: "",
        phoneNumber: "",
        loginpass: "",
        loginfullname: "",
        branchcode: "",
    });

const { t, i18n } = useTranslation()

    const [rowData, setstateRowData] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    // get state data from navigation 

    const [error, setError] = useState(false);
    const [message, setMessage] = useState("");

    const navigate = useNavigate();

    const resetSnakeBarMessages = () => {
        setError(null);
        setMessage(null);

    };

    const handleSubmit = async event => {
        // if form is not valid, do not submit
        if (!event.target.checkValidity()) {
            return;
        }
        event.preventDefault();
        setIsLoading(true);
        try {
            const data = { ...state, ...textInput }
            console.log(data);
            newRequest.post("/Postusers", data)

                .then((response) => {
                    setIsLoading(false);
                    console.log(response.data);
                    setMessage("User Added Successfully");
                })
                .catch((error) => {
                    setIsLoading(false);
                    console.log(error);
                    setError(error?.response?.data?.message ?? "Something went wrong");

                });
        } catch (error) {
            setIsLoading(false);
            console.log(error);
            setError(error?.response?.data?.message ?? "Something went wrong");

        }
    };
    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : 'teal',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));

    const handleSwitchToggle = (field) => (event) => {
        const newState = { ...state, [field]: event.target.checked ? 1 : 0 };
        console.log(newState);
        setState(newState);
    };

    return (
        <>

            {isLoading &&

                <div className='loading-spinner-background'
                    style={{
                        zIndex: 9999, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed'


                    }}
                >
                    <BeatLoader
                        size={18}
                        color={"#6439ff"}
                        // height={4}
                        loading={isLoading}
                    />
                </div>
            }

            <span
            >
                {message && <CustomSnakebar message={message} severity="success" onClose={resetSnakeBarMessages} />}
                {error && <CustomSnakebar message={error} severity="error" onClose={resetSnakeBarMessages} />}

                <div className="addNewUserForm">
                    {/* <Sidebar /> */}
                    <div className="newContainer">
                        {/* <Navbar /> */}
                        <div className={`top justify-between flex ${i18n.language==='ar'?'flex-row-reverse':'flex-row'}`}>
                            <span className={`topSpan justify-between flex ${i18n.language==='ar'?'flex-row-reverse':'flex-row'}`}>

                                <h1>{title}</h1>
                                <button
                                    onClick={() => navigate(-1)}
                                >{t('Go Back')}</button>
                            </span>
                        </div>
                        <div className="bottom">


                            <div className="right">
                                <form onSubmit={handleSubmit} id="myForm" >


                                    <div  className={`formInput ${i18n.language==='ar'? "direction-rtl":'text-start direction-ltr'}`}>
                                        <label htmlFor="loginname">{t('User Name')}*</label>
                                        <input type="text" placeholder={t("Login Name Here")} name="loginname" id="loginname" required
                                            onChange={(e) => setTextInput({ ...textInput, loginname: e.target.value })}

                                        />

                                    </div>
                                    <div className={`formInput ${i18n.language==='ar'? "direction-rtl":'text-start direction-ltr'}`}>
                                        <label htmlFor="loginpass">{t("Login Password")}*</label>
                                        <input
                                            onChange={(e) => setTextInput({ ...textInput, loginpass: e.target.value })}
                                            type="text" placeholder={t("password Here")} name="loginpass" id="loginpass" required />

                                    </div>
                                    <div className={`formInput ${i18n.language==='ar'? "direction-rtl":'text-start direction-ltr'}`}>
                                        <label htmlFor="email">{t("Email")}*</label>
                                        <input
                                            onChange={(e) => setTextInput({ ...textInput, email: e.target.value })}
                                            type="email" placeholder={t("Email Here")} name="email" id="email" required />

                                    </div>
                                    <div className={`formInput ${i18n.language==='ar'? "direction-rtl":'text-start direction-ltr'}`}>
                                        <label htmlFor="loginfullname">{t('Full Name')}</label>
                                        <input
                                            onChange={(e) => setTextInput({ ...textInput, loginfullname: e.target.value })}
                                            type="text" placeholder={t("Full Name Here")} name="loginfullname" id="loginfullname" required />

                                    </div>
                                    <div className={`formInput ${i18n.language==='ar'? "direction-rtl":'text-start direction-ltr'}`}>
                                        <label htmlFor="phoneNumber">{t("Phone Number")}</label>
                                        <input
                                            onChange={(e) => setTextInput({ ...textInput, phoneNumber: e.target.value })}
                                            type="text" placeholder={t("Phone Number Here")} name="phoneNumber" id="phoneNumber" />

                                    </div>
                                    <div className={`formInput ${i18n.language==='ar'? "direction-rtl":'text-start direction-ltr'}`}>
                                        <label htmlFor="branchcode">{t('Branch Code')}</label>
                                        <input
                                            onChange={(e) => setTextInput({ ...textInput, branchcode: e.target.value })}
                                            type="text" placeholder={t("Branch Code Here")} name="branchcode" id="branchcode" />

                                    </div>

                                    {Object.keys(state).map((field) => (
                                        <div className={`formInput ${i18n.language==='ar'? "direction-rtl":'text-start direction-ltr'}`}>
                                            <FormControlLabel
                                                key={field}
                                                control={
                                                    <IOSSwitch
                                                        sx={{ m: 1 }}
                                                        checked={state[field] === 1}
                                                        onChange={handleSwitchToggle(field)}
                                                    />
                                                }
                                                // first letter to uppercase

                                                // label={`${field.toUpperCase().charAt(0) + field.slice(1)} ACCESS`}
                                                label={t("Super Admin Access")}
                                            />
                                        </div>
                                    ))}

                                    <div className={`formInput ${i18n.language==='ar'? "direction-rtl":'text-start direction-ltr'}`}></div>
                                    <div className="buttonAdd" >
                                        <button
                                            type="submit"
                                        >{t('Add User')}</button>
                                    </div>
                                </form>
                            </div>
                        </div>


                    </div>
                </div >

            </span >
        </>
    );
};

export default AddNewUser;
